export function gridFields() {
    return Object.freeze([
        {
            key: 'id',
            label: 'lbl.basic.id',
            uneditable: true,
            notInTable: true,
            sortable: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'day',
            label: 'lbl.basic.date',
            sortable: true,
            form: {
              type: 'datepicker'
            }
        },
        {
            key: 'startDate',
            label: 'lbl.basic.startDay',
            uneditable: true,
            notInTable: true,
            filterable: true,
            form: {
              type: 'datepicker',
            }
        },
        {
            key: 'endDate',
            label: 'lbl.basic.endDay',
            uneditable: true,
            notInTable: true,
            filterable: true,
            form: {
              type: 'datepicker',
            }
        },
        {
            key: 'locName',
            label: 'lbl.fm.locationName',
            filterable: true,
            default: 'default',
            form: {
              type: 'dimSearch',
              url: process.env.VUE_APP_MASTER_API_URL + 'master-service/master/location/findAll',
              config: {
                validate: "", // 参数检查，可以是正则表达式等
                bindId: 'smeltingLocation', // 绑定的 id, (id 相同的对象会被绑定)
                bindProp: "locName", // 显示的属性的名称
                submitProp: "locName" // 提交的属性
              }
            }
        },
        {
            key: 'locId',
            label: 'lbl.formulaPlan.locationCode',
            notInTable: true,
            form: {
              type: 'dimSearch',
              url: process.env.VUE_APP_MASTER_API_URL + 'master-service/master/location/findAll',
              config: {
                validate: "", // 参数检查，可以是正则表达式等
                bindId: 'smeltingLocation', // 绑定的 id, (id 相同的对象会被绑定)
                bindProp: "id", // 显示的属性的名称
                submitProp: "id" // 提交的属性
              }
            }
        },
        {
            key: 'furnaceNumber',
            label: 'lbl.basic.furnaceName',
            filterable: true,
            sortable: true,
            default: 'default',
            form: {
                type: 'select',
                options: [
                  {value:"default", text:"lbl.basic.select.one"},
                  {value:"1", text:"opt.furnaceNumber1"},
                  {value:"2", text:"opt.furnaceNumber2"},
                  {value:"3", text:"opt.furnaceNumber3"},
                  {value:"4", text:"opt.furnaceNumber4"},
                  {value:"5", text:"opt.furnaceNumber5"},
                  {value:"6", text:"opt.furnaceNumber6"}
                ]
              }
        },
        {
            key: 'shift',
            label: 'lbl.basic.shift',
            filterable: true,
            sortable: true,
            default: 'default',
            form: {
              type: 'select',
              options: [
                { value: "default", text: "lbl.basic.select.one" },
                { value: "甲", text: "lbl.shift.A" },
                { value: "乙", text: "lbl.shift.B" },
                { value: "丙", text: "lbl.shift.C" }
              ]
            }
        },
        {
            key: 'powerCost',
            label: 'lbl.edp.powerCost',
            sortable: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'tubeFeed1',
            label: 'lbl.edp.tubeFeed1',
            sortable: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'tubeFeed2',
            label: 'lbl.edp.tubeFeed2',
            sortable: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'tubeFeed3',
            label: 'lbl.edp.tubeFeed3',
            sortable: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'electrodeDiff1',
            label: 'lbl.edp.electrodeDiff1',
            sortable: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'electrodeDischarge1',
            label: 'lbl.edp.electrodeDischarge1',
            sortable: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'electrodeDiff2',
            label: 'lbl.edp.electrodeDiff2',
            sortable: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'electrodeDischarge2',
            label: 'lbl.edp.electrodeDischarge2',
            sortable: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'electrodeDiff3',
            label: 'lbl.edp.electrodeDiff3',
            sortable: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'electrodeDischarge3',
            label: 'lbl.edp.electrodeDischarge3',
            sortable: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'bottomTemp12HStart',
            label: 'lbl.edp.bottomTemp12HStart',
            sortable: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'bottomTemp12HEnd',
            label: 'lbl.edp.bottomTemp12HEnd',
            sortable: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'bottomTemp12HDiff',
            label: 'lbl.edp.bottomTemp12HDiff',
            sortable: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'bottomTemp22HStart',
            label: 'lbl.edp.bottomTemp22HStart',
            sortable: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'bottomTemp22HEnd',
            label: 'lbl.edp.bottomTemp22HEnd',
            sortable: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'bottomTemp22HDiff',
            label: 'lbl.edp.bottomTemp22HDiff',
            sortable: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'bottomTemp32HStart',
            label: 'lbl.edp.bottomTemp32HStart',
            sortable: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'bottomTemp32HEnd',
            label: 'lbl.edp.bottomTemp32HEnd',
            sortable: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'bottomTemp32HDiff',
            label: 'lbl.edp.bottomTemp32HDiff',
            sortable: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'envTempStart',
            label: 'lbl.edp.envTempStart',
            sortable: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'envTempEnd',
            label: 'lbl.edp.envTempEnd',
            sortable: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'envTempDiff',
            label: 'lbl.edp.envTempDiff',
            sortable: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'coverTemp414Start',
            label: 'lbl.edp.coverTemp414Start',
            sortable: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'coverTemp414End',
            label: 'lbl.edp.coverTemp414End',
            sortable: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'coverTemp414Diff',
            label: 'lbl.edp.coverTemp414Diff',
            sortable: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'coverTemp424Start',
            label: 'lbl.edp.coverTemp424Start',
            sortable: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'coverTemp424End',
            label: 'lbl.edp.coverTemp424End',
            sortable: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'coverTemp424Diff',
            label: 'lbl.edp.coverTemp424Diff',
            sortable: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'coverTemp434Start',
            label: 'lbl.edp.coverTemp434Start',
            sortable: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'coverTemp434End',
            label: 'lbl.edp.coverTemp434End',
            sortable: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'coverTemp434Diff',
            label: 'lbl.edp.coverTemp434Diff',
            sortable: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'tapholeTemp150HStart',
            label: 'lbl.edp.tapholeTemp150HStart',
            sortable: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'tapholeTemp150HEnd',
            label: 'lbl.edp.tapholeTemp150HEnd',
            sortable: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'tapholeTemp150HDiff',
            label: 'lbl.edp.tapholeTemp150HDiff',
            sortable: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'tapholeTemp152HStart',
            label: 'lbl.edp.tapholeTemp152HStart',
            sortable: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'tapholeTemp152HEnd',
            label: 'lbl.edp.tapholeTemp152HEnd',
            sortable: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'tapholeTemp152HDiff',
            label: 'lbl.edp.tapholeTemp152HDiff',
            sortable: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'tapholeTemp153HStart',
            label: 'lbl.edp.tapholeTemp153HStart',
            sortable: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'tapholeTemp153HEnd',
            label: 'lbl.edp.tapholeTemp153HEnd',
            sortable: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'tapholeTemp153HDiff',
            label: 'lbl.edp.tapholeTemp153HDiff',
            sortable: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'tapholeTemp155HStart',
            label: 'lbl.edp.tapholeTemp155HStart',
            sortable: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'tapholeTemp155HEnd',
            label: 'lbl.edp.tapholeTemp155HEnd',
            sortable: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'tapholeTemp155HDiff',
            label: 'lbl.edp.tapholeTemp155HDiff',
            sortable: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'slagTemp250',
            label: 'lbl.edp.slagTemp250',
            sortable: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'slagTemp251',
            label: 'lbl.edp.slagTemp251',
            sortable: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'slagTemp252',
            label: 'lbl.edp.slagTemp252',
            sortable: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'slagTemp253',
            label: 'lbl.edp.slagTemp253',
            sortable: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'slagTemp254',
            label: 'lbl.edp.slagTemp254',
            sortable: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'slagTemp255',
            label: 'lbl.edp.slagTemp255',
            sortable: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'ironTemp131Start',
            label: 'lbl.edp.ironTemp131Start',
            sortable: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'ironTemp131End',
            label: 'lbl.edp.ironTemp131End',
            sortable: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'ironTemp131Diff',
            label: 'lbl.edp.ironTemp131Diff',
            sortable: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'ironTemp132Start',
            label: 'lbl.edp.ironTemp132Start',
            sortable: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'ironTemp132End',
            label: 'lbl.edp.ironTemp132End',
            sortable: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'ironTemp132Diff',
            label: 'lbl.edp.ironTemp132Diff',
            sortable: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'ironTemp133Start',
            label: 'lbl.edp.ironTemp133Start',
            sortable: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'ironTemp133End',
            label: 'lbl.edp.ironTemp133End',
            sortable: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'ironTemp133Diff',
            label: 'lbl.edp.ironTemp133Diff',
            sortable: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'drillDepth1',
            label: 'lbl.edp.drillDepth1',
            sortable: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'oxygenTube1',
            label: 'lbl.edp.oxygenTube1',
            sortable: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'slagStatus1',
            label: 'lbl.edp.slagStatus1',
            sortable: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'drillDepth2',
            label: 'lbl.edp.drillDepth2',
            sortable: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'oxygenTube2',
            label: 'lbl.edp.oxygenTube2',
            sortable: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'slagStatus2',
            label: 'lbl.edp.slagStatus2',
            sortable: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'drillDepth3',
            label: 'lbl.edp.drillDepth3',
            sortable: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'oxygenTube3',
            label: 'lbl.edp.oxygenTube3',
            sortable: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'slagStatus3',
            label: 'lbl.edp.slagStatus3',
            sortable: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'drillDepth4',
            label: 'lbl.edp.drillDepth4',
            sortable: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'oxygenTube4',
            label: 'lbl.edp.oxygenTube4',
            sortable: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'slagStatus4',
            label: 'lbl.edp.slagStatus4',
            sortable: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'drillDepth5',
            label: 'lbl.edp.drillDepth5',
            sortable: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'oxygenTube5',
            label: 'lbl.edp.oxygenTube5',
            sortable: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'slagStatus5',
            label: 'lbl.edp.slagStatus5',
            sortable: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'totalElectrodeDropStart',
            label: 'lbl.edp.totalElectrodeDropStart',
            sortable: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'totalElectrodeDropEnd',
            label: 'lbl.edp.totalElectrodeDropEnd',
            sortable: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'electrodeDrop1',
            label: 'lbl.edp.electrodeDrop1',
            sortable: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'electrodeDrop2',
            label: 'lbl.edp.electrodeDrop2',
            sortable: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'electrodeDrop3',
            label: 'lbl.edp.electrodeDrop3',
            sortable: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'preShiftCurrent1',
            label: 'lbl.edp.preShiftCurrent1',
            sortable: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'preShiftCurrentIndex1',
            label: 'lbl.edp.preShiftCurrentIndex1',
            sortable: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'preShiftCurrent2',
            label: 'lbl.edp.preShiftCurrent2',
            sortable: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'preShiftCurrentIndex2',
            label: 'lbl.edp.preShiftCurrentIndex2',
            sortable: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'preShiftCurrent3',
            label: 'lbl.edp.preShiftCurrent3',
            sortable: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'preShiftCurrentIndex3',
            label: 'lbl.edp.preShiftCurrentIndex3',
            sortable: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'transformerVoltageIndex1',
            label: 'lbl.edp.transformerVoltageIndex1',
            sortable: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'transformerVoltageIndex2',
            label: 'lbl.edp.transformerVoltageIndex2',
            sortable: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'transformerVoltageIndex3',
            label: 'lbl.edp.transformerVoltageIndex3',
            sortable: true,
            form: {
                type: 'input'
            }
        }
    ]);
}

 // class
 export const ElectrodeDischargePlan = function () {
    gridFields().forEach(item => {
      this[item.key] = item.default || '';
    })
  }
  
  
  export const filter = gridFields()
    .filter(v => v.filterable)
    .reduce((tar, v) => {
      tar[`${v.key}Filter`] = v.default || '';
      return tar
    }, {})
  export const filterFields = gridFields().filter(v => v.filterable).map(v => `filter.${v.key}`)